var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconDice = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-210.667 -12.667)" },
                React.createElement("g", { transform: "translate(221.667 5.365) rotate(45)" },
                    React.createElement("path", { d: "M20,13c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1\n\t\t\tC19.5,11.9,20,12.4,20,13L20,13z" }),
                    React.createElement("path", { d: "M27.6,13c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1\n\t\t\tS27.6,12.4,27.6,13L27.6,13z" }),
                    React.createElement("path", { d: "M12.4,13c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1\n\t\t\tC11.9,11.9,12.4,12.4,12.4,13L12.4,13z" })),
                React.createElement("g", { transform: "translate(208.5 10.5)" },
                    React.createElement("path", { d: "M9.6,7.4h15.2c1.2,0,2.2,1,2.2,2.2v15.2c0,1.2-1,2.2-2.2,2.2H9.6c-1.2,0-2.2-1-2.2-2.2V9.6\n\t\t\tC7.4,8.4,8.4,7.4,9.6,7.4z" })),
                React.createElement("g", { transform: "translate(203.282 23.75) rotate(-45)" },
                    React.createElement("path", { d: "M21.7,18.9c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1\n\t\t\tS21.7,18.3,21.7,18.9L21.7,18.9z" }),
                    React.createElement("path", { d: "M6.5,18.9C6.5,19.5,6,20,5.4,20c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1\n\t\t\tC6,17.8,6.5,18.3,6.5,18.9L6.5,18.9z" }))))));
});
export default IconDice;
//# sourceMappingURL=IconDice.js.map